/**
 * Keys and names used for authentication / session data.
 * On logout, everything in localStorage is cleared except PRESERVE_LOCAL_STORAGE_KEYS
 * (covers dynamic keys such as booking-status colors from the API).
 */

export const PRESERVE_LOCAL_STORAGE_KEYS = ['buildVersion'];

/** Cookie names set via js-cookie for auth */
export const AUTH_COOKIE_NAMES = ['token'];

/**
 * Explicit auth-related localStorage keys (login, profile, booking session, payments).
 * Also cleared via sweep in clearAuthData; kept for reference and build-version backup.
 */
export const AUTH_LOCAL_STORAGE_KEYS = [
  // Session / identity
  'token',
  'logged_user_id',
  'chef_id',
  'role',
  'chef_status',
  'owner',
  'user_email',
  'user_name',
  'user_image',
  'userData',
  'user_data',
  'isAuthenticated',
  'is_guest_user',

  // Subscription / plan
  'plan_status',
  'plan_id',
  'plan_name',
  'price',
  'status',
  'subscription_id',
  'card_added',

  // Address / profile
  'postalCode',
  'customer_address',
  'address',
  'line1',
  'line2',
  'city',
  'country',
  'temp_email',

  // Booking flow
  'redirect_to',
  'booking_completed',
  'booking_date',
  'booking_details',
  'timeslots',
  'food_categories',
  'food_categories_id',
  'food_categories_name',
  'chef_grocery_pickup',
  'allergies',
  'item_number_1',
  'item_number_2',
  'item_number_3',
  'item_number_4',
  'portion_1',
  'portion_2',
  'portion_3',
  'portion_4',
  'instructions_for_chef',
  'from_msg',
  'reminder_bookingId',
  'reminder_bookerName',

  // Payments
  'paypal_vault_id',
  'customer_id',

  // Chef onboarding (sign-in without token path)
  'bank_added',
  'profile_updated',

  // Multi-tab logout signal (removed after set in clearAuthData)
  'logout',
];
